import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\UpdateDiaryChiftAccountingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/UpdateDiaryChiftAccountingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-accounting'
*/
const UpdateDiaryChiftAccountingLinkController = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftAccountingLinkController.url(args, options),
    method: 'put',
})

UpdateDiaryChiftAccountingLinkController.definition = {
    methods: ["put"],
    url: '/api/accounting-diary/{accounting_diary}/partners/chift-accounting',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\UpdateDiaryChiftAccountingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/UpdateDiaryChiftAccountingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-accounting'
*/
UpdateDiaryChiftAccountingLinkController.url = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_diary: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: typeof args.accounting_diary === 'object'
        ? args.accounting_diary.id
        : args.accounting_diary,
    }

    return UpdateDiaryChiftAccountingLinkController.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\UpdateDiaryChiftAccountingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/UpdateDiaryChiftAccountingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-accounting'
*/
UpdateDiaryChiftAccountingLinkController.put = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftAccountingLinkController.url(args, options),
    method: 'put',
})

export default UpdateDiaryChiftAccountingLinkController